import React, { useState } from 'react';
import { Tooltip, IconButton, ClickAwayListener, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { TOOLTIP_VALUES, TOOLTIP_TYPES } from '../../constants/ToolTipInfo/ToolTipContent';
import './Tooltip.css';

// render helper method
const typeRenderers = {
  //different types like text, captions, lists etc can be rendered, just in case
  text: (value) => <Typography variant="body2">{value}</Typography>,
  caption: (value) => (
    <Typography variant="caption" color="text.secondary">
      {value}
    </Typography>
  ),
  list: (value) => (
    <ul className="tooltip-list">
      {value.map((item) => (
        <li>
          <Typography variant="body2">{item}</Typography>
        </li>
      ))}
    </ul>
  ),
  html: (value) => value, // could be anything
};

//actual component
export const InfoTooltip = ({ contentKey, content, title }) => {
  const [open, setOpen] = useState(false);

  const type = content?.type || TOOLTIP_TYPES[contentKey] || 'text';
  const value = content?.value || TOOLTIP_VALUES[contentKey] || '';
  const renderContent = typeRenderers[type] || typeRenderers.text;

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className="clickaway">
        <Tooltip
          PopperProps={{ disablePortal: true }} //preventing from rendering in a portal, keeps it in DOM
          open={open}
          onClose={() => setOpen(false)}
          disableFocusListener //disables nonclick listeners
          disableHoverListener
          disableTouchListener
          placement="top"
          componentsProps={{
            //this is to pass in sx
            tooltip: {
              sx: {
                border: '0.8px solid rgba(0, 0, 0, 0.3)',
                bgcolor: 'white',
                color: '#333',
                fontSize: '14px',
                padding: '16px',
                borderRadius: '10px',
                boxShadow: 'none',
                maxWidth: '300px',
                textAlign: 'left',
              },
            },
          }}
          title={
            <>
              {title && (
                <Typography variant="body2" gutterBottom>
                  {/* adds bottom space since it is a paragarph */}
                  {title}
                </Typography>
              )}
              {/* fallback with link if falsy*/}
              {value ? (
                renderContent(value) //continue with falsy
              ) : (
                <Typography variant="body2">
                  Unavailable – please{' '}
                  <a className="tooltip-fallback-link" href="/contact">
                    read the disclaimer
                  </a>
                  .
                </Typography>
              )}
            </>
          }
        >
          <IconButton
            onClick={() => setOpen((prev) => !prev)}
            size="small"
            sx={{
              padding: 0,
              verticalAlign: 'top',
              //   transform: 'translateY(-0.1rem)',
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};
